import React, { FunctionComponent } from 'react';
import { Background } from '../../../types/background';
import RichText from '../../RichText';
import './styles.scss';

type OneColumnProps = {
  data: {
    background: Background;
    content: any;
  };
}

const OneColumn: FunctionComponent<OneColumnProps> = ({ data }) => {
  return (
    <section className={`one-column ${data.background}`}>
      <div className='one-column-container'>
        <RichText
          value={data.content}
        />
      </div>
    </section>
  );
}

export default OneColumn;
